import { gql } from '@apollo/client';
export const UPDATE_BRAND = gql`
	mutation UpdateBrand($brandInfo: UpdateOnboardingBrandInput!) {
		updateBrandSalesforce(updateBrand: $brandInfo) {
			success
			message
		}
	}
`;
